import { Component, Input, OnInit } from '@angular/core';

import { FidelidadeService } from '../../../_services/fidelidade.service';
import { Notificacao } from './../../../_models/notificacao';
import { Membro } from 'src/app/modules/_models/membro';
import { Router } from '@angular/router';
import * as _ from 'lodash';

@Component({
  selector: 'app-notificacoes',
  templateUrl: './notificacoes.component.html',
  styleUrls: ['./notificacoes.component.scss'],
  providers: [],
})
export class NotificacoesComponent implements OnInit {
  // ** inputs ** //
  @Input() public exibeBotaoVerMais: boolean = false;

  // ** variaveis de tela ** //
  public numeroAExibir: number = 5;
  public notificacoes: Array<Notificacao> = [];
  public exibeDivSemNotificacoes: boolean = false;

  private listGrupoNotificacoes: Array<Notificacao> = [];
  private quantidade: number = 5;

  public carregandoNotificacoes: boolean = false;

  public membro: Membro = null;

  constructor(
    private fidelidadeService: FidelidadeService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.obterNotificacoes();
  }

  // ** EVENTOS DE TELA **/
  public onClickVerMais() {
    this.numeroAExibir += this.quantidade;

    this.filtrarNotificacoesTela();
  }

  public exibirBotaoCarregarMais() {
    return this.numeroAExibir < this.listGrupoNotificacoes.length;
  }

  // ** METODOS PRIVADOS ** //
  private obterNotificacoes() {
    this.carregandoNotificacoes = true;

    this.fidelidadeService.obterMembro().subscribe((sucesso: Membro) => {
      this.membro = sucesso;
      this.fidelidadeService
        .ObterGrupoNotificacaoPorIdMembroOuNivel(
          true,
          sucesso.id,
          sucesso.idNivel
        )
        .subscribe(
          (sucesso) => {
            this.processarSucessoObterGrupoNotificacaoPorIdMembroOuNivel(
              sucesso
            );
          },
          (falha) => {
            this.processarFalhaObterGrupoNotificacaoPorIdMembroOuNivel(falha);
          }
        );
      (falha) => {
        this.processarFalhaObterGrupoNotificacaoPorIdMembroOuNivel(falha);
      };
    });
  }

  private processarSucessoObterGrupoNotificacaoPorIdMembroOuNivel(
    response: any
  ) {
    for (let index = 0; index < response.length; index++) {
      const element = response[index].notificacao;

      this.listGrupoNotificacoes.push(element);
    }

    this.carregandoNotificacoes = false;

    this.filtrarNotificacoesTela();
  }

  private processarFalhaObterGrupoNotificacaoPorIdMembroOuNivel(response: any) {
    console.error(response);
    this.exibirDivSemNotificacoes();
  }

  private filtrarNotificacoesTela() {
    this.limparNotificacoes();

    let notificacoes: any[] = [];

    if (this.listGrupoNotificacoes.length <= 0) this.exibirDivSemNotificacoes();

    for (let index = 0; index < this.listGrupoNotificacoes.length; index++) {
      // if (index >= this.listGrupoNotificacoes.length) return;

      const element = this.listGrupoNotificacoes[index];

      element.lida = false;
      if (element.notificacaoStatus.length > 0)
        element.lida = element.notificacaoStatus[0].lida;

      notificacoes.push(element);
    }

    notificacoes = notificacoes.reverse();
    this.notificacoes = notificacoes;
  }

  private limparNotificacoes() {
    this.notificacoes = [];
  }

  private exibirDivSemNotificacoes() {
    this.exibeDivSemNotificacoes = true;
  }

  public redirecionar(notificacao: Notificacao) {
    this.fidelidadeService
      .marcarNotificacaoComoLida(notificacao, this.membro.id)
      .subscribe(
        (sucesso) => {
          if (notificacao.linkBotao.includes('http'))
            window.open(notificacao.linkBotao, '_blank')
          else
            this.router.navigate([notificacao.linkBotao]);
        },
        (falha) => {
          if (notificacao.linkBotao.includes('http'))
            window.open(notificacao.linkBotao, '_blank')
          else
            this.router.navigate([notificacao.linkBotao]);
        }
      );
    (falha) => {
      this.processarFalhaObterGrupoNotificacaoPorIdMembroOuNivel(falha);
    };
  }
}
